import SvgIcon from "./SvgIcon";

export default function RunIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M19.99 13.33a3.7 3.7 0 0 1-3.32-2l-.17-.32h-1.01l-.17.32a3.763 3.763 0 0 1-6.65 0l-.17-.32H7.49l-.17.32a3.72 3.72 0 0 1-3.32 2 3.7 3.7 0 0 1-3.01-1.51v1.88a5.02 5.02 0 0 0 3.01.98 5.054 5.054 0 0 0 4-1.92 5.116 5.116 0 0 0 7.99 0 5.122 5.122 0 0 0 7.01.94v-1.88a3.71 3.71 0 0 1-3.01 1.51zm-7.99 8a3.725 3.725 0 0 1-3.33-2L8.49 19H7.5l-.18.33a3.7 3.7 0 0 1-3.32 2 3.7 3.7 0 0 1-3.01-1.51v1.89c.873.64 1.929.98 3.01.97a5.054 5.054 0 0 0 4-1.92 5.054 5.054 0 0 0 4 1.92 4.947 4.947 0 0 0 3-.98v-1.87a3.654 3.654 0 0 1-3 1.5zm8-16.02a3.735 3.735 0 0 1-3.33-2L16.51 3h-1.02l-.16.31a3.724 3.724 0 0 1-3.33 2 3.681 3.681 0 0 1-3-1.5V5.7a5.04 5.04 0 0 0 3 .96 5.024 5.024 0 0 0 4-1.92 5.023 5.023 0 0 0 4 1.92 5.124 5.124 0 0 0 3-.95v-1.9a3.654 3.654 0 0 1-3 1.5z"
        fill={color}
      />
    </SvgIcon>
  )
}
